import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { UpdateStaffProductFlagsRequest } from '@/definitions/staff'
import { UpdateStaffProductFlags } from '@/services/StaffService'

interface UpdateStaffProductFlagsVariables {
  orgId: string
  staffId: string
  data: UpdateStaffProductFlagsRequest
}

export const useUpdateStaffProductFlags = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ orgId, staffId, data }: UpdateStaffProductFlagsVariables) =>
      UpdateStaffProductFlags(orgId, staffId, data),
    // The E-Prescribe section reports a failure beside the switch that caused it,
    // which a generic toast cannot do. Callers outside it should report it themselves.
    meta: { suppressGlobalError: true },
    onSuccess: (_staff, { orgId }) => {
      // Query keys match by prefix, so this covers the list and every staff
      // member's detail under it — the switch reads the stored flag off that
      // refreshed record rather than assuming the request took effect.
      queryClient.invalidateQueries({ queryKey: ['staff', orgId] })
    },
  })
}
